/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:keydownEventUtility
//
// <<Modification History>>
// Version	| Date		 | Updated By			 | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/11/02 | 富士通株式会社		 | 新規作成
//================================================================================
 */

/*
 * ショートカットキーによるページバックを中止する
 */
export function co_pageBackCancel(event) {
	let tagName = "";
	let type = "";
	let readOnly = false;
	let disabled = false;

	// イベント発生元要素の情報を取得
	if (typeof event.target.tagName !== "undefined" && event.target.tagName !== false) {
		tagName = event.target.tagName.toLowerCase();
	}
	if (typeof event.target.type !== "undefined" && event.target.type !== false) {
		type = event.target.type.toLowerCase();
	}
	if (typeof event.target.readOnly !== "undefined" && event.target.readOnly !== false) {
		readOnly = event.target.readOnly;
	}
	if (typeof event.target.disabled !== "undefined" && event.target.disabled !== false) {
		disabled = event.target.disabled;
	}

    // Google Chrome、Microsoft Edge対応
	// [Alt]+←を無効
	if (event.altKey && event.keyCode == 37) {
		event.preventDefault();
		return;
	}

	// Safari対応
	// [left command]+{を無効
	if (event.metaKey && event.keyCode == 219) {
		if ((tagName === "input" && (type === "text" || type === "password")) || tagName === "textarea") {
			// テキストボックス・パスワード・テキストエリアの場合
			if (!readOnly && !disabled) {
				// 入力可能の場合は有効
				event.preventDefault();
				return;
			}
		}
		event.preventDefault();
		return;
	}

	// [right command]+{を無効
	if (event.metaKey && event.keyCode == 219) {
		if ((tagName === "input" && (type === "text" || type === "password")) || tagName === "textarea") {
			// テキストボックス・パスワード・テキストエリアの場合
			if (!readOnly && !disabled) {
				// 入力可能の場合は有効
				event.preventDefault();
				return;
			}
		}
		event.preventDefault();
		return;
	}

    // IE対応
	// BackSpaceを無効
	if (event.keyCode == 8) {
		if ((tagName === "input" && (type === "text" || type === "password")) || tagName === "textarea") {
			// テキストボックス・パスワード・テキストエリアの場合
			if (!readOnly && !disabled) {
				// 入力可能の場合は有効
				event.preventDefault();
				return;
			}
		}
		event.preventDefault();
		return;
	}
	return true;
}